import KeyMetric from '@/pages/CompanyReport/components/Overview/components/DeprecatedHeader/components/KeyMetric';
import PencilOutline from '@simplywallst/ui-core/icons/PencilOutline';

type Props = {
  onClick: () => void;
};

export const DefaultState = ({ onClick }: Props) => {
  return (
    <KeyMetric
      type="Metric"
      testId="my-fair-value"
      title="My Fair Value"
      metric={
        <span
          className="grid cursor-pointer grid-cols-[max-content_max-content] items-center gap-1"
          onClick={onClick}
        >
          <span className="m-0 text-xs text-accent">Select</span>
          <PencilOutline className="size-x2 fill-accent" />
        </span>
      }
    />
  );
};
